import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';
import Validated from 'components/util/Validated';
import * as FormSections from 'catalogs/components/form/sections';

import { createRoute } from 'lib/util';

const CatalogsForm = ({
  company,
  errors,
  handleAddElement,
  handleRemoveElement,
  handleSubmit,
  handleValueChange,
  isSaving,
  isSubmitted,
  subcompany,
  t,
  values,
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <FormSections.General
        errors={errors}
        values={values}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
      />
      <FormSections.Elements
        errors={errors}
        values={values}
        handleValueChange={handleValueChange}
        handleAddElement={handleAddElement}
        handleRemoveElement={handleRemoveElement}
        isSubmitted={isSubmitted}
      />

      <div className="col-md-12 mt-3">
        <Form.Button
          type={'submit'}
          text={t('actions.save')}
          isLoading={isSaving}
          disabled={isSaving}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={createRoute(company.id, subcompany.id, `catalogs`)}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isSaving,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated({
  type: 'object',
  properties: {
    elements: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            minLength: 1,
          },
          value: {
            type: 'string',
            minLength: 1,
          },
          active: {
            type: 'boolean',
          },
          deleted: {
            type: 'boolean',
          },
        },
        required: ['key', 'value', 'active', 'deleted'],
      },
    },
  },
  required: ['elements'],
})(translate()(CatalogsForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/form/CatalogForm.js